module.exports = __webpack_public_path__ + "static/media/guide.1537c2ca.svg";